import { render, staticRenderFns } from "./fbSideBar.vue?vue&type=template&id=ba3bc24e&"
import script from "./fbSideBar.vue?vue&type=script&lang=js&"
export * from "./fbSideBar.vue?vue&type=script&lang=js&"
import style0 from "./fbSideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports